import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'

import TextField from '@material-ui/core/TextField'
import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import SubmitButton from 'components/atoms/buttons/SubmitButton'

export const styles = theme => ({
  root: {
    textAlign: 'center',
    padding: `0 ${theme.spacing(1)}px`,
  },
  errorMessage: {
    padding: `${theme.spacing(2)}px 0`,
  },
  formControl: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  formHelperTextLarge: {
    bottom: -25,
  },
  formControlButton: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(1),
  },
})

const NewPasswordForm = ({
  classes,
  className: classNameProp,
  errors,
  handleFieldChange,
  hasFieldError,
  isSubmitting,
  handleFormSubmit,
  values,
}) => {
  const className = classNames(classes.root, classNameProp)
  return (
    <div className={className}>
      <form noValidate autoComplete="off" onSubmit={handleFormSubmit}>
        <FormControl
          className={classes.formControl}
          fullWidth
          error={hasFieldError('password')}>
          <TextField
            id="password-input"
            name="password"
            label="Password"
            value={values.password}
            onChange={handleFieldChange}
            type="password"
            autoComplete="password"
            error={hasFieldError('password')}
            margin="normal"
            inputProps={{
              maxLength: 1024,
            }}
          />
          {hasFieldError('password') ? (
            <FormHelperText className={classes.formHelperTextLarge}>
              {errors.password}
            </FormHelperText>
          ) : null}
        </FormControl>
        <FormControl
          className={classes.formControl}
          fullWidth
          error={hasFieldError('repeatPassword')}>
          <TextField
            id="repeatPassword"
            name="repeatPassword"
            label="Repeat Password"
            value={values.repeatPassword}
            onChange={handleFieldChange}
            type="password"
            autoComplete="repeatPassword"
            error={hasFieldError('repeatPassword')}
            margin="normal"
            inputProps={{
              maxLength: 1024,
            }}
          />
          {hasFieldError('repeatPassword') ? (
            <FormHelperText>{errors.repeatPassword}</FormHelperText>
          ) : null}
        </FormControl>
        <FormControl className={classes.formControlButton} fullWidth>
          <SubmitButton
            autoFocus
            size="large"
            type="submit"
            color="primary"
            variant="primary"
            disabled={isSubmitting}>
            Reset Password
          </SubmitButton>
        </FormControl>
      </form>
    </div>
  )
}

NewPasswordForm.propTypes = {
  actions: PropTypes.object,
  classes: PropTypes.object,
  className: PropTypes.string,
  errors: PropTypes.object,
  handleCheckboxChange: PropTypes.func,
  handleFieldChange: PropTypes.func,
  hasFieldError: PropTypes.func,
  handleFormSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
  rememberMe: PropTypes.bool,
  onReset: PropTypes.func,
  status: PropTypes.string,
  values: PropTypes.object,
}

NewPasswordForm.defaultProps = {}

export default withStyles(styles)(NewPasswordForm)



// WEBPACK FOOTER //
// ./src/components/organisms/NewPasswordForm/NewPasswordForm.js